import React, { useEffect } from "react";
import { Button, Container } from "reactstrap";
import successImg from "../../components/assets/support-desk.jpg";
import { useNavigate } from "react-router-dom";

function RequestedBulkOrder() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 7000); // 7000ms = 7 seconds

    return () => clearTimeout(timer); // Cleanup the timer on unmount
  }, [navigate]);

  const handleGoToHomePage = () => {
    navigate("/");
  };

  return (
    <Container className="flex flex-col justify-center items-center text-center h-[100vh]">
      <img src={successImg} className="w-2/3 sm:w-1/3" />
      <p className="text-2xl font-semibold">Thank you for choosing Solmelu!</p>
      <Container className="mt-7 text-gray-500">
        <p>Our Buyers Support Desk will reach out to you shortly.</p>
      </Container>
      <Button
        onClick={handleGoToHomePage}
        className="outline-none mt-5 bg-[#800000] w-2/3 sm:w-1/4 text-white font-semibold py-3 uppercase rounded-xl active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
      >
        Continue Shopping
      </Button>
    </Container>
  );
}

export default RequestedBulkOrder;
